import { FC } from 'react'

import { Stack, Typography } from '@mui/material'

import { COMPETITIONS_LIST_MIN_HEIGHT } from './constants'

type EmptyCompetitionsStateProps = {
  message?: string
}

export const EmptyCompetitionsState: FC<EmptyCompetitionsStateProps> = ({
  message = 'No competitions available'
}) => {
  return (
    <Stack
      justifyContent="center"
      alignItems="center"
      sx={{
        height: '100%',
        minHeight: COMPETITIONS_LIST_MIN_HEIGHT
      }}
    >
      <Typography variant="body2" color="text.secondary">
        {message}
      </Typography>
    </Stack>
  )
}
